export default {
  path: '/lvy-privacy-policy',
  component: () => import('./LVYPrivacyPolicy'),
  meta: {
    title: '青藤之恋隐私政策',
    designWidth:750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
